export enum Weight {
    best = 'best', good = 'good', bad = 'bad', worst = 'worst'
}
